import { CENTER, EMPLOYEE } from "../constants/mainAPI";
import { doDeleteRequest, doGetRequest, doPostRequest, doPutRequest } from "./mainAPI";
import {
    EmployeeDataCreate,
    EmployeeDataEdit,
    EmployeesSuccessResponse,
    EmployeeSuccessResponse,
} from "../types/api/employee";
import { toFormData } from "../utils/toFormData";
import { getFileFromUrl } from "../utils/getFileFromUrl";
import { ErrorResponseType } from "../types/api/main";

export const getEmployees = (
    centerId: string | undefined,
    callback?: (resp: EmployeesSuccessResponse) => any,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
    searchParams?: Record<string, any>,
) => {
    return doGetRequest(`${CENTER}/${centerId || 0}/${EMPLOYEE}`, true, searchParams, callback, errorCallback);
};

export const getEmployee = (
    centerId: string | undefined,
    employeeId: number | undefined,
    callback?: (resp: EmployeeSuccessResponse) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    return doGetRequest(`${CENTER}/${centerId || 0}/${EMPLOYEE}/${employeeId}`, true, {}, callback, errorCallback);
};

export const createNewEmployee = async (
    centerId: string | undefined,
    data: EmployeeDataCreate,
    callback?: (resp: EmployeeSuccessResponse) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    // const modifyData = {...data, work_position: data.work_position.map(work=>work.value)}
    // console.log(modifyData)
    const formData = toFormData(data);
    if (data?.photos?.length > 1) {
        let promises = [] as any;
        await data.photos.forEach((v: any, index: Number) => {
            v &&
                promises.push(
                    getFileFromUrl(v.photo.file, v.photo.name).then(r => {
                        r && formData.append(`photos[${index}]`, r);
                    }),
                );
        });
        await Promise.all(promises).finally(() => {
            return doPostRequest(`${CENTER}/${centerId || 0}/${EMPLOYEE}`, true, formData, {}, callback, errorCallback);
        });
    } else {
        return doPostRequest(`${CENTER}/${centerId || 0}/${EMPLOYEE}`, true, formData, {}, callback, errorCallback);
    }
};

export const editEmployee = async (
    centerId: string | undefined,
    employeeId: number | undefined,
    data: EmployeeDataEdit,
    callback?: (resp: EmployeeSuccessResponse) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    const formData = toFormData(data);
    if (data.delete_photos && data.delete_photos?.length > 0) {
        data.delete_photos?.forEach((v: any, index: Number) => {
            formData.append(`delete_photos[${index}]`, v);
        });
    }
    if (data?.photos?.length > 1) {
        let promises = [] as any;
        await data.photos.forEach((v: any, index: Number) => {
            v?.photo?.file &&
                promises.push(
                    getFileFromUrl(v.photo.file, v.photo.name).then(r => {
                        r && formData.append(`photos[${index}]`, r);
                    }),
                );
        });
        await Promise.all(promises).finally(() => {
            return doPutRequest(
                `${CENTER}/${centerId || 0}/${EMPLOYEE}/${employeeId}`,
                true,
                formData,
                {},
                callback,
                errorCallback,
            );
        });
    } else {
        return doPutRequest(
            `${CENTER}/${centerId || 0}/${EMPLOYEE}/${employeeId}`,
            true,
            formData,
            {},
            callback,
            errorCallback,
        );
    }
};

export const deleteEmployee = (
    centerId: string | undefined,
    employeeId: number | undefined,
    callback?: (resp: any) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    return doDeleteRequest(`${CENTER}/${centerId || 0}/${EMPLOYEE}/${employeeId}`, true, {}, callback, errorCallback);
};
